<footer *ngIf="!IsLogin">
    <div class="footer-top-wrapper">
        <br />
        <br />
        <div class="text-center">
            <p class="text-default">
                © {{Year}} {{copyright}}
            </p>
        </div>
    </div>

</footer>
<footer class="fooetr_afterlg_section" *ngIf="IsLogin" >
    <div class="container-fluid">
        <div class="fooetr_aft_lgin_wrap">
            <div class="footer_aft_left_wrap">

                <p>© {{Year}} Virtusa. All rights reserved</p>
            </div>
            <!-- <div class="footer_aft_right_wrap">
                <ul>
                    <li><a>About Us</a></li>
                    <li><a>Contact Us</a></li>
                    <li><a>Terms & Condtions</a></li>
                    <li><a>Privacy Policy</a></li>
                </ul>
            </div> -->
        </div>
    </div>
</footer>
